declare namespace $ {

	export class $mol_icon_stop extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=stop.view.tree.d.ts.map